import HTTP from '../../../../api/AxiosConfig';

export const getEmployeesPage = (pageRequest) =>
    HTTP.post('/employee/employees-page', pageRequest);

export const save = (employee) =>
    HTTP.post('/employee/save', employee);

export const deleteEmployee = (employeeId) =>
    HTTP.delete('/employee?id=' + employeeId);

export const getEmployees = () =>
    HTTP.get(`/employee/employees`);